// Query keys centralizadas y jerárquicas del dominio cms.
export const cmsKeys = {
  all: ["cms"] as const,
  peopleCulture: () => [...cmsKeys.all, "people-culture"] as const,
  file: (fileId?: string, extension?: string) =>
    [...cmsKeys.all, "file", fileId, extension] as const,
} as const;
